import type { NotificationMessage } from '../../types/entities';

import type LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { get } from '@helsenorge/framework-utils/cms-content-api-service';

export interface IAdditionalPageContent {
  messages: NotificationMessage[];
}

/**
 * Hent driftsmeldinger og infomeldinger for side på tjenester.helsenorge.no
 * @param path Path til siden, f.eks. provesvar
 * @param languageCode Språkkode
 * @returns Driftsmeldinger og infomeldinger
 */
export const getContentForPath = async (path: string, languageCode?: LanguageLocales): Promise<IAdditionalPageContent | null> =>
  get('additionalpagecontent/search', { path, languageCode });

/**
 * Hent driftsmeldinger og infomeldinger for side på www.helsenorge.no
 * @param contentReference Side-ID i CMS
 * @param languageCode Språkkode
 * @returns Driftsmeldinger og infomeldinger
 */
export const getContentForContentReference = async (
  contentReference: string,
  languageCode?: LanguageLocales
): Promise<IAdditionalPageContent | null> =>
  get(`additionalpagecontent/contentreference/${contentReference}`, {
    languageCode,
  });
